export default __webpack_public_path__ + "static/media/footerLogin.eae14ccf.png";